import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { DefaultModal } from '@libs/ui/components/modals';

interface SuccessApplyModalProps {
  open: boolean;
  handleClose: VoidFunction;
}

const SuccessApplyModal = ({ open, handleClose }: SuccessApplyModalProps) => {
  const { t } = useTranslation('jobBoard');
  return (
    <DefaultModal
      open={open}
      handleClose={handleClose}
      title={t('applySuccess.title')}
    >
      <Grid spacing={4} direction="column" container>
        <Grid item>{t('applySuccess.body')}</Grid>
      </Grid>
    </DefaultModal>
  );
};

export default SuccessApplyModal;
